import FolioCheckbox from '@/components/FolioCheckbox';
import {
	useCreateOrUpdateNotificationUserMutation,
	useGetNotificationsUserQuery,
} from '@/features/notifications/notificationsApi';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { Switch } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const UserNotification = ({ type, action: actionType }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails, isLoading } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const { data: active, ...notificationUsersQuery } = useGetNotificationsUserQuery(
		{ userId: userDetails?.userId, type },
		{
			skip: !userDetails?.userId,
			selectFromResult: ({ data, ...rest }) => ({
				...rest,
				data: !data
					? false
					: Boolean(data.actions?.find((d) => d.action === actionType)?.active),
			}),
		},
	);

	const [addUser, addUserState] = useCreateOrUpdateNotificationUserMutation();

	const handleChange = async () => {
		await addUser({
			userId: userDetails?.userId,
			type,
			actions: [{ action: actionType, active: !active }],
		}).unwrap();
	};

	return (
		<FolioCheckbox
			key={type}
			component={Switch}
			checked={active}
			label={`Email me when ${actionType === 'complete' ? 'completed' : actionType === 'assigned' ? 'assigned to me' : actionType}`}
			onChange={handleChange}
			disabled={isLoading || addUserState.isLoading || notificationUsersQuery.isLoading}
		/>
	);
};

export default UserNotification;
